var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.372 0 0 5.373 0 12C0 18.627 5.372 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM12.14 19.018C8.272 19.018 5.14 15.878 5.14 12C5.14 8.122 8.272 4.982 12.14 4.982C14.03 4.982 15.61 5.679 16.822 6.811L14.848 8.789V8.785C14.113 8.083 13.181 7.723 12.14 7.723C9.83 7.723 7.953 9.679 7.953 11.996C7.953 14.311 9.83 16.273 12.14 16.273C14.236 16.273 15.662 15.071 15.956 13.421H12.14V10.684H18.725C18.813 11.154 18.86 11.644 18.86 12.158C18.86 16.168 16.183 19.018 12.14 19.018Z",
    fill: "url(#paint0_linear_2421_4726)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2421_4726",
    x1: 30.4675,
    y1: -11.2174,
    x2: -10.2711,
    y2: -4.99158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006CCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00509A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.57f36f06.svg";
export { ForwardRef as ReactComponent };